export enum UserWalletTransactionReferenceModelEnum {
    USER_TO_COOK_PAYMENT = 'USER_TO_COOK_PAYMENT',
    ONE_MEAL_SERVICE = 'ONE_MEAL_SERVICE',
    DISCOUNT_COUPON_ORDER = 'DISCOUNT_COUPON_ORDER',
    CHEF_FOR_PARTY_ORDER = 'CHEF_FOR_PARTY_ORDER',
    PROMOTIONAL_BALANCE = 'PROMOTIONAL_BALANCE',
}
